import { Controller } from "stimulus";

// Find a way to get rid of this controller. // TODO: remove this controller.

// Mirrors edit_profile_controller behaviour.
// The form is primarily handled by api-sync; this controller keeps legacy hooks.
export default class extends Controller {
  static values = { updateUrl: String };

  connect() {
    this.debounceTimer = null;
  }

  submit(_event) {
    this.post();
  }

  debouncedSubmit(_event) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.post(), 300);
  }

  // Intentionally left blank (legacy).
  post() {}
}

